import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../constants';

const TOCDashboard = () => {
  const [brandShare, setBrandShare] = useState(null);
  const [categoryShare, setCategoryShare] = useState(null);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    axios.post(`${API_URL}/calculate-toc/`)
      .then(response => {
        setBrandShare(response.data.brand_share);
        setCategoryShare(response.data.category_share);
      })
      .catch(error => {
        console.error("Error fetching TOC:", error);
      });
  }, []);

  if (!brandShare || !categoryShare) {
    return (
      <div className="p-4 ml-4">
        <h2 className="text-2xl font-bold mb-4">Total Ownership Coefficient (Snusbolaget, 1.-13.6.2025)</h2>
        <p>Loading...</p>
      </div>
    );
  }

  const filteredBrandShare = filter
    ? brandShare.filter(row => row['Brand'].includes(filter))
    : brandShare;

  return (
    <div className="p-4 ml-4">
      <h2 className="text-2xl font-bold mb-4">Total Ownership Coefficient (Snusbolaget, 1.-13.6.2025)</h2>

      <input
        type="text"
        placeholder="Filter by brand..."
        className="mb-4 p-2 border"
        value={filter}
        onChange={e => setFilter(e.target.value)}
      />

      <div className="mb-6">
        <h3 className="text-xl font-semibold">Brand Share within Categories</h3>
        <table className="w-full border-collapse mt-2">
          <thead>
            <tr>
              <th className="border p-2">Category</th>
              <th className="border p-2">Brand</th>
              <th className="border p-2">Count</th>
              <th className="border p-2">Share (%)</th>
            </tr>
          </thead>
          <tbody>
            {filteredBrandShare.map((row, idx) => (
              <tr key={idx}>
                <td className="border p-2">{row.Category}</td>
                <td className="border p-2">{row.Brand}</td>
                <td className="border p-2">{row.Count}</td>
                <td className="border p-2">{row['Share_%'].toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <h3 className="text-xl font-semibold">Category Share (Site Occupation)</h3>
        <table className="w-full border-collapse mt-2">
          <thead>
            <tr>
              <th className="border p-2">Category</th>
              <th className="border p-2">Count</th>
              <th className="border p-2">Share (%)</th>
            </tr>
          </thead>
          <tbody>
            {categoryShare.map((row, idx) => (
              <tr key={idx}>
                <td className="border p-2">{row.Category}</td>
                <td className="border p-2">{row.Count}</td>
                <td className="border p-2">{row['Category_Share_%'].toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TOCDashboard;

